import React, {
  useState,
  FunctionComponent,
  useMemo,
  useCallback,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationCrosshairs } from "@fortawesome/free-solid-svg-icons";

const LocationRequester: FunctionComponent<LocationRequesterProps> = ({
  onLocation,
}) => {
  const inDev = useMemo(
    () =>
      window.location.host.includes("localhost") ||
      window.location.port === "3000",
    []
  );

  const initialCheckSupport = useMemo(() => {
    if (inDev) {
      return true;
    }

    if (window.location.protocol !== "https:") {
      return false;
    }

    return navigator.geolocation != null;
  }, [inDev]);

  const [isGeolocationAvailable, setIsGeolocationAvailable] =
    useState<boolean>(initialCheckSupport);

  const getLocation = useCallback(() => {
    if (inDev === true) {
      onLocation([144.2172, -37.0633]);
      return;
    }

    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser");
      setIsGeolocationAvailable(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        onLocation([longitude, latitude]);
      },
      (error) => {
        console.error("Error fetching location:", error.message);
        setIsGeolocationAvailable(false);
      }
    );
  }, [inDev, onLocation]);

  if (!isGeolocationAvailable) {
    return null;
  }

  return (
    <div className="tw-flex-grow tw-mt-4">
      <hr />
      <div className="tw-text-center">or</div>
      <div className="tw-text-center">
        <button
          className="tw-border tw-rounded-full tw-p-1 tw-px-3 tw-w-max tw-border-black tw-text-black tw-font-button tw-mt-2 tw-mx-auto"
          onClick={getLocation}
        >
          <FontAwesomeIcon
            icon={faLocationCrosshairs}
            className="tw-pr-2 tw-inline"
          />
          Search near me
        </button>
      </div>
    </div>
  );
};

type LocationRequesterProps = {
  onLocation: (position: [number, number]) => void;
};

export default React.memo(LocationRequester);
